<template>
  <div class="f-ast f-v">
    <div class="t t-xl ta-c m-tx3 m-bx3">
      <div class="m-bx2">
        <span class="t t-2xl">✅</span>
      </div>
      <div class="bold m-bx2">
        Request Submitted Successfully
      </div>
      <div>
        We received your request to set up gift card rewards and we're on it!
      </div>
      <br>
      <div class="t t-s c-muted">
        Our team will reach out in 1-2 business days to complete gift card setup for your invoiced account.
      </div>
    </div>
    <donut-modal-sections-actions
      button-text="Close"
      :show-cancel="false"
    />
  </div>
</template>
